import React from 'react';
import { InvitationExpiredPageStyle as S } from './InvitationExpiredPage.style';
import { VStack } from 'components/layouts/primitives/Stack/Stack';
import { Icon } from 'components/Icon/Icon';
import { Text } from 'components/Text/Text';
import { LinkText } from 'components/LinkText/LinkText';
import { Box } from 'components/layouts/primitives/Box/Box';
import { YabbleLogo } from 'components/YabbleLogo/YabbleLogo';

export const InvitationExpiredPage: React.FC = () => {
  return (
    <S.Container>
      <VStack fit="space" splitAfterIdx={0}>
        <S.Content fit="space">
          <S.Content fit="space">
            <Box padding={['padding3XL', 'paddingNone']} fit="space">
              <VStack gap="gap4" align="center" fit="space" stretch justify="center">
                <Icon icon="linkBroken01Line" size={32} />
                <Text as="h1" size="fontSizeXL" lineHeight="lineHeight2XL" weight="medium" align="center">
                  Invitation Link Expired
                </Text>
                <Text as="p" color="neutral500" align="center">
                  Your invitation has expired. Please contact your administrator to receive a new invitation.
                </Text>
                <Text as="p" color="neutral500" align="center">
                  <LinkText as="a" href={window.location.origin}>
                    Log in here
                  </LinkText>{' '}
                  if you’ve already signed up.
                </Text>
              </VStack>
            </Box>
          </S.Content>
        </S.Content>
        <S.Content fit="content">
          <S.Footer fit="space">
            <VStack gap="gap4" align="center">
              <YabbleLogo height={32} color="neutral400" />
              <Text as="p" size="fontSizeXS" lineHeight="lineHeightSM" color="neutral400" align="center">
                For further assistance, feel free to reach out at{' '}
                <LinkText as="a" href="mailto:hello@yabblezone.net" severity="primary">
                  hello@yabblezone.net
                </LinkText>
                .
              </Text>
            </VStack>
          </S.Footer>
        </S.Content>
      </VStack>
    </S.Container>
  );
};
